"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRoommateSelection = parseRoommateSelection;
exports.isRoommateSelectionConfirmation = isRoommateSelectionConfirmation;
exports.roommateSelectionFingerprint = roommateSelectionFingerprint;
exports.roommateSelectionChanged = roommateSelectionChanged;
const selectionKeys = [
    'floorplanId',
    'unitId',
    'unitSpaceId',
    'leaseTermId',
    'leaseStartWindowId',
    'spaceConfigurationId',
];
function parseRoommateSelection(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        throw new Error('Invalid unit selection');
    }
    const result = {};
    const fields = value;
    for (const key of selectionKeys) {
        const identifier = fields[key];
        if (identifier == null)
            continue;
        if ((typeof identifier !== 'string' && typeof identifier !== 'number') ||
            !/^\d+$/.test(String(identifier)) ||
            !Number.isSafeInteger(Number(identifier))) {
            throw new Error('Invalid unit selection identifier');
        }
        result[key] = Number(identifier);
    }
    return result;
}
function isRoommateSelectionConfirmation(value) {
    if (!value || typeof value !== 'object')
        return false;
    const context = value;
    try {
        return (Number.isSafeInteger(context.membershipId) &&
            context.membershipId > 0 &&
            context.originalSelectionFingerprint ===
                roommateSelectionFingerprint(parseRoommateSelection(context.originalSelection)) &&
            (context.supersedesTargetFingerprint === undefined ||
                /^\d+(?::\d+){5}$/.test(context.supersedesTargetFingerprint)) &&
            typeof context.targetSelectionFingerprint === 'string' &&
            /^\d+(?::\d+){5}$/.test(context.targetSelectionFingerprint));
    }
    catch {
        return false;
    }
}
/** Stable across JSON numeric/string identifiers and omitted unassigned fields. */
function roommateSelectionFingerprint(selection) {
    return selectionKeys.map((key) => Number(selection[key]) || 0).join(':');
}
function roommateSelectionChanged(previous, next) {
    return roommateSelectionFingerprint(previous) !== roommateSelectionFingerprint(next);
}
